import * as types from "../actions/epic.action";
const INITIAL_STATE = {
   epicCredDetails: null,
};

export default function epic(state = INITIAL_STATE, action) {
   switch (action.type) {
      case types.SET_EPIC_CREDS:
         return {
            ...state,
            epicCredDetails: action.payload,
         };
      default:
         return state;
   }
}
